import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import en from './locales/en.json';
import ar from './locales/ar.json';

// Clear translation cache in development
if (process.env.NODE_ENV === 'development') {
  // Clear any cached translations
  Object.keys(localStorage).forEach(key => {
    if (key.startsWith('i18next') || key.includes('translation')) {
      localStorage.removeItem(key);
    }
  });
  Object.keys(sessionStorage).forEach(key => {
    if (key.startsWith('i18next') || key.includes('translation')) {
      sessionStorage.removeItem(key);
    }
  });
  
  // Force clear all i18next related data
  localStorage.removeItem('i18nextLng');
  sessionStorage.removeItem('i18nextLng');
  
  // Clear all storage to force fresh load
  localStorage.clear();
  sessionStorage.clear();
}

// Load both locales under a single namespace tree so component keys like
// t('quotations.*') resolve at the root. Avoid scattering same keys under
// different top-level groups which may cause lookups to miss.
const resources = {
  en: { translation: en },
  ar: { translation: ar }
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'ar',
    debug: process.env.NODE_ENV === 'development',
    defaultNS: 'translation',
    ns: ['translation'],

    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    },

    detection: {
      order: ['localStorage', 'sessionStorage', 'navigator', 'htmlTag'],
      caches: [],  // Disable all caching in development
      lookupLocalStorage: 'i18nextLng',
      lookupSessionStorage: 'i18nextLng',
    },

    // Completely disable caching in development to ensure fresh translations
    saveMissing: false,
    updateMissing: false,
    cache: false,
    
    // Force reload in development
    initImmediate: false,
    load: 'all',
    preload: ['ar', 'en'],
    
    // Reload resources on language change
    reloadOnPrerender: true,
  });

// Force reload resources in development
if (process.env.NODE_ENV === 'development') {
  i18n.reloadResources().then(() => {
    console.log('🔄 i18n resources reloaded');
  });
}

export default i18n; 